import Vue from 'vue'
import VueRouter from 'vue-router'
import MainLayout from "@/views/MainLayout";
import DashBoard from "@/views/agent/DashBoard";
import LoginView from "@/views/LoginView";
import store from "@/store"

Vue.use(VueRouter)

const routes = [
  {
        path: '/',
        redirect: 'login'
    },
  {
    path: '/home',
    name: 'home',
    meta: { layout: MainLayout, auth: true, role: 'admin'  },
    component: DashBoard,
  },
  {
    path: '/access-denied',
    name: 'access-denied',
    meta: { layout: MainLayout, auth: true, role: 'user' },
    component: () => import('@/views/accessDenied')
  },
  {
    path: '/travel',
    name: 'travel',
    meta: { layout: MainLayout, auth: true, role: 'user' },
    component: () => import('@/views/agent/createPolicy'),
  },
  {
    path: '/user',
    name: 'user',
    meta: { layout: MainLayout, auth: true, role: 'user' },
    component: () => import('@/views/agent/userView'),
  },
  {
    path: '/motor',
    name: 'motor',
    meta: { layout: MainLayout, auth: true },
    component: () => import('@/views/agent/createMotor'),
  },
  // {
  //   path: '/endorse',
  //   name: 'endorse',
  //   meta:{layout:MainLayout,auth:true},
  //   component: ()=>import('@/views/agent/endorseView'),
  // },
  // {
  //   path: '/endorse/create/:id',
  //   meta:{layout:MainLayout,auth:true},
  //   component: ()=>import('@/views/agent/endorseForm'),
  // },
  {
    path: '/travel-search',
    name: 'travel-search',
    meta: { layout: MainLayout, auth: true, role: 'admin' },
    component: () => import('@/views/agent/searchView'),
  },
  {
    path: '/motor-search',
    name: 'motor-search',
    meta: { layout: MainLayout, auth: true },
    component: () => import('@/views/agent/searchMotor'),
  },
  {
    path: '/travel-report',
    name: 'travel-report',
    meta: { layout: MainLayout, auth: true, role: 'admin' },
    component: () => import('@/views/agent/reportView'),
  },
  {
    path: '/motor-report',
    name: 'motor-report',
    meta: { layout: MainLayout, auth: true },
    component: () => import('@/views/agent/reportMotor'),
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    if (store.getters.isLoggedIn) {
      if (store.getters.userRole === to.meta.role || store.getters.userRole === 'admin') {
        next()
        return
      }

      next('/access-denied')
      return;

    }
    next('/login')
  } else {
    next()
  }
})

export default router
